import styled from 'styled-components';
import ExpandableNotice from './ExpandableNotice';

export function SellerNoticeContent({ content }: { content: string }) {
  return <><strong>(셀러)</strong><ExpandableNotice content={content} collapsedLines={2} /></>;
}

export default function SellerNotice({ content }: { content: string }) {
  if (!content.trim()) return null;
  return <Notice role="note" aria-label="셀러 공지"><SellerNoticeContent content={content} /></Notice>;
}

const Notice = styled.aside`
  position: relative; z-index: 1; flex-shrink: 0; box-sizing: border-box;
  display: flex; align-items: flex-start; gap: var(--space-2); min-width: 0;
  margin: var(--space-3) var(--space-4);
  padding: var(--space-3); border: 1px solid var(--color-brand); border-radius: var(--radius-md);
  background: var(--color-brand-subtle); color: var(--color-text-primary);
  font-family: var(--font-family-base); font-size: var(--text-caption); line-height: var(--leading-caption);
  strong { flex-shrink: 0; color: var(--color-text-link); font-weight: 600; white-space: nowrap; }
  > div { flex: 1; max-height: calc(var(--space-12) * 4); overflow-y: auto; }
`;
